/* LAVISH Drop: Countdown (Drop-Leiste + Drop-Sperre) und Early Access.
   Klein, ohne Abhängigkeiten, wird mit defer geladen. */
(function () {
  if (window.__lvdrop) return;
  window.__lvdrop = true;
  var KEY = 'lvea';
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function setN(e, v) { if (e && e.textContent !== v) e.textContent = v; }
  function zoned(y, mo, d, h, mi, tz) {
    var want = Date.UTC(y, mo - 1, d, h, mi), t = want;
    try {
      var f = new Intl.DateTimeFormat('en-US', { timeZone: tz, hourCycle: 'h23', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' });
      for (var k = 0; k < 2; k++) {
        var p = {};
        f.formatToParts(new Date(t)).forEach(function (x) { p[x.type] = +x.value; });
        t += want - Date.UTC(p.year, p.month - 1, p.day, p.hour % 24, p.minute);
      }
      return t;
    } catch (e) { return new Date(y, mo - 1, d, h, mi).getTime(); }
  }
  function endOf(el) {
    var d = (el.getAttribute('data-date') || '').split('-'), t = (el.getAttribute('data-time') || '0:0').split(':');
    if (d.length !== 3) return NaN;
    return zoned(+d[0], +d[1], +d[2], +t[0] || 0, +t[1] || 0, el.getAttribute('data-tz') || 'Europe/Berlin');
  }
  function stored() { try { return localStorage.getItem(KEY) || ''; } catch (e) { return ''; } }
  function store(v) { try { localStorage.setItem(KEY, v); } catch (e) {} }
  function sha(v) {
    if (!window.crypto || !crypto.subtle || !window.TextEncoder) return Promise.resolve('');
    return crypto.subtle.digest('SHA-256', new TextEncoder().encode(v)).then(function (b) {
      return Array.prototype.map.call(new Uint8Array(b), function (x) { return ('0' + x.toString(16)).slice(-2); }).join('');
    });
  }
  /* Code aus dem Link (?ea=CODE) merken */
  try {
    var q = new URLSearchParams(location.search).get('ea');
    if (q) store(q.trim().toUpperCase());
  } catch (e) {}

  /* ---------- Countdown ---------- */
  function initCd(root) {
    if (root.__lvdcd) return;
    root.__lvdcd = true;
    var end = endOf(root);
    var el = {};
    ['d', 'h', 'm', 's'].forEach(function (k) { el[k] = root.querySelector('[data-u="' + k + '"]'); });
    var timer;
    function done() {
      root.classList.add('is-live');
      root.dispatchEvent(new CustomEvent('lvdrop:live', { bubbles: true }));
    }
    if (isNaN(end) || root.getAttribute('data-mode') === 'live') { done(); return; }
    function tick() {
      var left = Math.max(0, end - Date.now());
      if (left <= 0) { done(); return; }
      var sec = Math.floor(left / 1000);
      /* nur geänderte Ziffern schreiben (weniger DOM-Änderungen pro Sekunde) */
      setN(el.d, pad(Math.floor(sec / 86400)));
      setN(el.h, pad(Math.floor(sec % 86400 / 3600)));
      setN(el.m, pad(Math.floor(sec % 3600 / 60)));
      setN(el.s, pad(sec % 60));
      timer = setTimeout(tick, 1000 - (Date.now() % 1000) + 5);
    }
    document.addEventListener('visibilitychange', function () {
      clearTimeout(timer);
      if (!document.hidden && !root.classList.contains('is-live')) tick();
    });
    tick();
  }

  /* ---------- Drop-Sperre (Produktseite) ---------- */
  function unlock(lock, why) {
    document.documentElement.removeAttribute('data-lvlock');
    lock.classList.add('is-open');
    lock.setAttribute('data-why', why);
  }
  function initLock(lock) {
    if (lock.__lvlock) return;
    lock.__lvlock = true;
    var hash = lock.getAttribute('data-hash') || '';
    lock.addEventListener('lvdrop:live', function () { unlock(lock, 'time'); });
    function tryCode(v) {
      if (!hash || !v) return Promise.resolve(false);
      return sha(v.trim().toUpperCase()).then(function (h) {
        if (h && h === hash) { store(v.trim().toUpperCase()); unlock(lock, 'code'); return true; }
        return false;
      });
    }
    tryCode(stored());
    var form = lock.querySelector('[data-lvlock-form]');
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      var inp = form.querySelector('input');
      tryCode(inp ? inp.value : '').then(function (ok) {
        var m = form.querySelector('[data-lvlock-msg]');
        if (m) m.textContent = ok ? '' : (form.getAttribute('data-wrong') || '');
      });
    });
    /* Kauf-Klicks abfangen, solange gesperrt (falls CSS umgangen wird) */
    document.addEventListener('submit', function (e) {
      if (document.documentElement.hasAttribute('data-lvlock') && e.target.closest && e.target.closest('product-form-component, [data-type="add-to-cart-form"]')) { e.preventDefault(); e.stopImmediatePropagation(); }
    }, true);
  }

  /* ---------- Drop-Leiste: E-Mail-Feld auf/zu ---------- */
  function initBar(bar) {
    if (bar.__lvbar) return;
    bar.__lvbar = true;
    var t = bar.querySelector('[data-lvbar-mail]');
    var f = bar.querySelector('[data-lvbar-form]');
    if (t && f) t.addEventListener('click', function () {
      var open = f.hasAttribute('hidden');
      if (open) f.removeAttribute('hidden'); else f.setAttribute('hidden', '');
      t.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) { var i = f.querySelector('input[type="email"]'); if (i) i.focus(); }
    });
  }

  /* ---------- Drop-Leiste: Hero-Text nie verdecken ----------
     Misst, wie weit die schwebende Leiste ins Titelbild darüber ragt, und gibt das dem Hero als --lvbar-clear. */
  function fitHero(bar) {
    if (bar.__lvfit || !bar.hasAttribute('data-lvbar-fit')) return;
    var sec = bar.closest('.shopify-section'), prev = sec && sec.previousElementSibling;
    var hero = prev && prev.querySelector('.lvh'), box = bar.querySelector('.lvbar__box');
    if (!hero || !box) return;
    bar.__lvfit = true;
    var mq = window.matchMedia('(min-width:750px)'), last = '';
    function upd() {
      if (!box.offsetHeight) return; /* ausgeblendet/noch nicht gelayoutet: Schätzwert aus dem CSS behalten */
      var cs = getComputedStyle(bar);
      var off = parseFloat(cs.getPropertyValue(mq.matches ? '--lvbar-offd' : '--lvbar-off')) || 0;
      var over = -(parseFloat(getComputedStyle(sec).marginTop) || 0);
      if (over < 0) over = 0;
      var v = Math.ceil(bar.offsetHeight + off + over) + 'px', key = (mq.matches ? 'd' : 'm') + v;
      if (key === last) return;
      last = key;
      /* Handy und Desktop getrennt, damit beim Umschalten nie ein falscher Wert kurz greift */
      hero.style.setProperty(mq.matches ? '--lvbar-cleard' : '--lvbar-clear', v);
      hero.setAttribute('data-lvbar-clear', '');
    }
    upd();
    if (window.ResizeObserver) new ResizeObserver(upd).observe(bar); /* Leiste inkl. Text-Blöcke darüber */
    if (mq.addEventListener) mq.addEventListener('change', function () { last = ''; upd(); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(upd);
    window.addEventListener('load', upd);
  }

  function run() {
    /* Sperren zuerst, damit sie das „live“-Signal des Countdowns mitbekommen */
    document.querySelectorAll('[data-lvlock]').forEach(initLock);
    document.querySelectorAll('[data-lvbar]').forEach(initBar);
    document.querySelectorAll('[data-lvbar-fit]').forEach(fitHero);
    document.querySelectorAll('[data-lvdrop-cd]').forEach(initCd);
  }
  window.LavishDrop = { run: run, store: store };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
  document.addEventListener('shopify:block:select', run);
})();
